import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import EnterLayout from '../layout/EnterLayout';
import { getParsedParams } from '../../utils/consts/params';
import { saveFromOrderAuthParams } from '../../utils/authInterceptor';
import { sendPermTokenRequest } from '../../utils/api/accountApi';
import { genericErrorMessage } from '../../utils/lang/commonErrors';
import AuthFormSwitch from './otc/AuthFormSwitch';
import styles from './EnterForm.scss';

const EnterForm = () => {
  const intl = useIntl();

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = getParsedParams();

    saveFromOrderAuthParams();

    if (params.ERROR === 'ErrAccountTerminated') {
      window.location.href = '/enter/restore';
    } else if (params.ERROR) {
      setError(params.ERROR);
    }

    if (params.PERMANENT_TOKEN) {
      sendPermTokenRequest(params.PERMANENT_TOKEN, { shouldDropToLogin: false }).then(() => {
        window.location.href = '/profile';
      });
    }
  }, []);

  return (
    <EnterLayout showTermsAndPolicy verticalPaddings={45}>
      {error ? (
        <span className={styles.errorInfo}>
          {error === 'ErrDevicesPerAccountLimitExceeded'
            ? intl.formatMessage({
                id: 'enter.error.deviceLimitExceeded',
                defaultMessage: 'Devices limit exceeded, please log in to manage your devices',
                description:
                  'Error message show to user with exceeded maximum number of devices; ' +
                  'user should log in to remove unneeded devices from their profile page.',
              })
            : error === 'ErrAccountAlreadyExists'
              ? intl.formatMessage(
                  {
                    id: 'enter.error.accountAlreadyExists',
                    defaultMessage:
                      'This account already exists.{br}Try using another email or <supportLink>contact support</supportLink> to transfer your Premium plan to your old account.',
                    description:
                      'Error message shown, when user tries to sign up with an email, that`s already registered',
                  },
                  {
                    br: <br />,
                    supportLink: (chunk) => <a href="https://support.clearvpn.com/hc/?open_chat=1">{chunk}</a>,
                  },
                )
              : intl.formatMessage(genericErrorMessage)}
        </span>
      ) : null}

      <AuthFormSwitch />
    </EnterLayout>
  );
};

export default EnterForm;
